module.exports = __webpack_public_path__ + "img/tick_icon_color.779f5294.svg";